import { Card, Statistic, Typography } from "antd";
import type { ReactNode } from "react";

const { Text } = Typography;

interface StatCardProps {
  title: string;
  value: number | string;
  prefix?: ReactNode;
  suffix?: string;
  precision?: number;
  hint?: string;
  loading?: boolean;
}

/**
 * Cartão de vidro (glassmorphism) para os dashboards. Usado nos placeholders de
 * CUSTO de IA, qualidade de classificação e saúde.
 */
export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  prefix,
  suffix,
  precision,
  hint,
  loading,
}) => {
  return (
    <Card className="mel-glass" bordered={false} loading={loading}>
      <Statistic
        title={title}
        value={value}
        prefix={prefix}
        suffix={suffix}
        precision={precision}
        valueStyle={{ color: "#0E7490", fontWeight: 700 }}
      />
      {hint && (
        <Text type="secondary" style={{ fontSize: 12 }}>
          {hint}
        </Text>
      )}
    </Card>
  );
};
